import {
  fetchCollection,
  fetchResource,
} from './index'

import get from 'lodash/get'
import at from 'lodash/at'
import moment from 'moment'
import { inspectionSchema } from '../schemas'

export const LOCATION_INSPECTIONS_REQUEST = 'LOCATION_INSPECTIONS_REQUEST'
export const LOCATION_INSPECTIONS_SUCCESS = 'LOCATION_INSPECTIONS_SUCCESS'
export const LOCATION_INSPECTIONS_FAILURE = 'LOCATION_INSPECTIONS_FAILURE'

function fetchInspectionsForLocation (locationId, url, reload, options) {
  return fetchCollection({
    url,
    key: 'inspections',
    schema: inspectionSchema,
    actions: [ LOCATION_INSPECTIONS_REQUEST, LOCATION_INSPECTIONS_SUCCESS, LOCATION_INSPECTIONS_FAILURE ],
    responseInterceptor: (response) => ({ ...response, locationId, reload }),
    ...options,
  })
}

export const INSPECTION_REQUEST = 'INSPECTION_REQUEST'
export const INSPECTION_SUCCESS = 'INSPECTION_SUCCESS'
export const INSPECTION_FAILURE = 'INSPECTION_FAILURE'

export function fetchInspection (id) {
  return fetchResource({
    url: `/inspections/${id}`,
    key: 'inspection',
    schema: inspectionSchema,
    actions: [ INSPECTION_REQUEST, INSPECTION_SUCCESS, INSPECTION_FAILURE ]
  })
}

export function loadInspectionsForLocation (locationId, nextPage) {
  return (dispatch, getState) => {
    let {
      nextPageUrl
    } = get(getState(), `pagination.inspectionsByLocation.${locationId}`, {})

    let {
      areaId,
      inspectorId,
      startDate,
      endDate,
    } = get(getState(), `inspectionFilters.${locationId}`, {})

    if (startDate) startDate = startDate.toISOString()
    if (endDate) endDate = endDate.toISOString()

    if (!nextPage) {
      nextPageUrl = `/locations/${locationId}/inspections`
    }

    return dispatch(
      fetchInspectionsForLocation(
        locationId,
        nextPageUrl,
        !nextPage,
        { query: { areaId, startDate, endDate, inspectorId } }
      )
    )
  }
}

// FILTERS

export function setInitialInspectionFilters (locationId) {
  return (dispatch, getState) => {
    const location = get(getState(), `locations.${locationId}`, {})
    const contracts = at(getState().contracts, location.contracts || [])

    if (contracts.length > 0) {
      const { startDate, endDate } = contracts[0]
      return dispatch(setInspectionFilters(locationId, { startDate, endDate }))
    } else {
      return dispatch(
        setInspectionFilters(
          locationId,
          { startDate: moment().startOf('year'), endDate: moment().endOf('year') }
        )
      )
    }
  }
}

export const SET_INSPECTION_FILTERS = 'SET_INSPECTION_FILTERS'

export function setInspectionFilters (locationId, filter) {
  return {
    type: SET_INSPECTION_FILTERS,
    payload: {
      locationId,
      filter,
    }
  }
}



// WEBPACK FOOTER //
// ./src/actions/inspections.js